import React, { useState } from 'react';
import { Form, Transition, Button, Link, Document } from 'components';
import { api, isEmail, cookies, encrypt, delay, config, useQuery, useLocation } from 'helpers';
import { errors } from '.';
import css from './short.scss';

export function Login(props) {
  let { email, redirect } = useQuery();
  const { search } = useLocation();
  const [ state, setState ] = useState({
    email: email || '',
  });

  async function login({ values, setError, setPending, setSuccess }) {
    if (!values.email) {
      return setError('email', 'please enter your email');
    } else if (!isEmail(values.email)) {
      return setError('email', 'please enter valid email');
    } else if (!values.password) {
      return setError('password', 'please enter your password');
    }

    setPending();

    try {
      cookies.remove('token', { domain: config.appHost });
      cookies.remove('signing-up', { domain: config.appHost });

      const { token } = await api('/login/', {
        email: values.email,
        password: values.password,
        device: 'Web',
      });

      cookies.set('token', encrypt(token), { expires: 365, domain: config.appHost });
      cookies.set('email', values.email, { expires: 365 });

      setSuccess();

      await delay(1000);

      if (props.module == 'upgrade') {
        redirect = '/settings/membership/';
      }
      window.location = `https://app.${config.appHost}${redirect || '/'}?${Math.random()}`;

    } catch ({ error }) {
      const field = /password/.test(error) ? 'password' : 'email';
      setError(field, errors[error] || 'Error. Please try again');
      setPending(false);
    }
  }

  function logout() {
    cookies.remove('token', { domain: config.appHost });
    cookies.remove('email');
    setState({});
  }

  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <Form onSubmit={login} state={state} setState={setState} className={css('form', 'appear'+props.status)} autoComplete="off">
        <Document.Title>Login</Document.Title>
        <p><Form.Text name="email" label="Email" /></p>
        <p><Form.Password name="password" label="Password" /></p>
        <p className={css.tip}>
          Forgot your password? <Link to={`/restore/${search}`}>Restore</Link>
        </p>
        <p><Form.Submit>Login</Form.Submit></p>
        <p className={css.footer}>
          <span>Don't have an account? </span>
          <Link to={`/sign-up/${search}`}>Sign Up</Link>
        </p>
        { state.success &&
          <div className={css.cover}>
            <p>redirecting now..</p>
          </div>
        }
        <Transition in={cookies.get('token') && cookies.get('email') && !state.pending} mountOnEnter unmountOnExit classNames={css.locals}>
          <div className={css.loggedIn}>
            <p>You are logged in as <b>{ cookies.get('email') }</b></p>
            <p><Button href={`https://app.${config.appHost}/?${Math.random()}`}>Continue</Button></p>
            <p className={css.footer}><u onClick={logout}>Login with another account</u></p>
          </div>
        </Transition>
      </Form>
    </Transition>
  );
}
